module.exports = __webpack_public_path__ + "static/travel_app_cover-647973ea953c97e5967af49a85d6e6f2.png";